// Chi gioca in casa sta a SINISTRA: è il modo in cui si leggono calendari e tabelloni.
//
// Prima il gestionale metteva **sempre** la nostra squadra a sinistra, anche in trasferta: la partita
// si leggeva al contrario di come si è giocata (in trasferta gioca in casa l'avversario). Segnalato
// da Stefano e sistemato il 12/10/2026, sia a schermo sia nella stampa settimanale.
//
// Nella tabella `partite` la colonna `luogo` vale 'Casa' o 'Trasferta'. Un valore vuoto vale 'Casa',
// come il modulo quando si crea una partita.
//
// Sta in un file suo per poter essere provato senza montare la pagina: `src/ordinePartita.test.js`.

export function ordinePartita({ luogo, nostra, avversario }) {
  const inCasa = String(luogo || 'Casa').trim().toLowerCase() !== 'trasferta'
  const noi = nostra || '—'
  const loro = avversario || '—'
  return inCasa
    ? { inCasa: true, sinistra: noi, destra: loro }
    : { inCasa: false, sinistra: loro, destra: noi }
}

// La riga "chi contro chi" che si legge a schermo e nelle stampe: "CASA vs OSPITE", con chi gioca in
// casa sempre a sinistra. La usano l'elenco delle convocazioni, l'intestazione della partita, il testo
// WhatsApp, l'elenco delle partite da convocare e la stampa della lista convocati: una regola sola,
// così calendario e convocazioni non possono dire due cose diverse (chiesto da Stefano il 17/10/2026).
export function testoPartita({ luogo, nostra, avversario }) {
  const { sinistra, destra } = ordinePartita({ luogo, nostra, avversario })
  return `${sinistra} vs ${destra}`
}

// La dizione che si legge nelle stampe: la stessa che usa la distinta di gara ("dove si gioca").
// Sta qui, in un punto solo, così schermo e stampe non possono dire due cose diverse.
export function etichettaVerso(inCasa) {
  return inCasa ? '🏠 IN CASA' : '🚌 IN TRASFERTA'
}
